<nb-card [attr.aria-busy]="loading || saving">
  <nb-card-header class="detail-heading">
    <button nbButton size="small" type="button" class="back-button" (click)="closeDetail.emit()" [disabled]="saving">Back to agents</button>
    <span>Agent details</span>
    <div class="header-actions">
      <button *ngIf="agent && !loading && !error && !editing" nbButton size="small" status="primary"
              type="button" (click)="startEdit()" [disabled]="saving">Edit</button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="loading" class="state-message" role="status">Loading agent details…</div>
    <div *ngIf="!loading && error" class="state-message" role="alert">
      <p>{{ error }}</p>
      <button nbButton size="small" type="button" (click)="retry.emit()">Retry</button>
    </div>
    <div *ngIf="!loading && !error && !agent" class="state-message">Select an agent to view details.</div>

    <ng-container *ngIf="!loading && !error && agent">
      <div class="detail-summary">
      <section class="agent-profile" *ngIf="!editing">
        <h2>{{ agent.name || 'Unnamed agent' }}</h2>
        <p class="agency-name">{{ agent.agency?.name || 'Agency unavailable' }}</p>
        <div class="tag-list" *ngIf="agent.positions?.length; else noPositions">
          <span class="position-tag" *ngFor="let position of agent.positions">{{ position }}</span>
        </div>
        <ng-template #noPositions><p class="muted">Position unavailable</p></ng-template>
        <dl class="profile-fields">
          <dt>Phone</dt><dd>{{ agent.phone || '—' }}</dd>
          <dt>Postcodes</dt>
          <dd>
            <div class="tag-list" *ngIf="agent.postcodes?.length; else noPostcodes">
              <span class="postcode-tag" *ngFor="let postcode of agent.postcodes">{{ postcode }}</span>
            </div>
            <ng-template #noPostcodes>—</ng-template>
          </dd>
        </dl>
      </section>

      <form *ngIf="editing" id="agent-profile-form" class="profile-form" (ngSubmit)="save()">
        <fieldset [disabled]="saving">
          <div class="edit-grid">
            <label for="agent-name">Name
              <input nbInput fullWidth id="agent-name" name="name" required [(ngModel)]="draft.name">
            </label>
            <label for="agent-phone">Phone
              <input nbInput fullWidth id="agent-phone" name="phone" type="tel" maxlength="64" [(ngModel)]="draft.phone">
            </label>
            <label for="agent-titles" class="full-row">Titles <span class="muted">(one per line)</span>
              <textarea nbInput fullWidth id="agent-titles" name="titles" rows="3" [(ngModel)]="titlesDraft"></textarea>
            </label>
            <label for="recruitment-rate">Commission rate (%)
              <input nbInput fullWidth id="recruitment-rate" name="rate" type="number" min="0" max="100" step="0.0001"
                     [(ngModel)]="draft.rate" placeholder="e.g. 2">
            </label>
          </div>
        </fieldset>
        <p class="metric-note">Later imports may refresh profile details. Commission rate is retained.</p>
      </form>
      <p *ngIf="!editing" class="commission-rate">Commission rate: <strong>{{ agent.rate != null ? (agent.rate | number:'1.0-4') + '%' : '—' }}</strong></p>
      <section class="summary-metrics" aria-label="Sales summary">
        <div><span>Sold listings</span><strong>{{ agent.recentListings?.length || 0 }}</strong></div>
        <div><span>Sale volume (AUD)</span><strong>{{ agent.totalRecentListingAmount != null ? (agent.totalRecentListingAmount | currency:'AUD':'symbol-narrow':'1.0-2') : '—' }}</strong></div>
        <div><span>GCI (AUD)</span><strong>{{ displayedGci != null ? (displayedGci | currency:'AUD':'symbol-narrow':'1.0-2') : '—' }}</strong></div>
        <div><span>Median sold price (AUD)</span><strong>{{ agent.medianSoldPrice != null ? (agent.medianSoldPrice | currency:'AUD':'symbol-narrow':'1.0-2') : '—' }}</strong></div>
      </section>
      <p class="metric-note">Total listing value includes disclosed prices only. Median sold price comes from the agent profile.</p>


      </div>
      <section class="sold-listings">
        <h3>Recent sold listings <span class="listing-count">({{ agent.recentListings?.length || 0 }})</span></h3>
        <p *ngIf="!agent.recentListings?.length" class="muted">No sold listings have been imported for this agent.</p>
        <div class="listing-scroll" tabindex="0" role="region" aria-label="Recent sold listings">
        <article class="listing" *ngFor="let listing of agent.recentListings; trackBy: trackListing"
                 [class.is-linked]="listing.matchStatus === 'MATCHED' && listing.prospectId"
                 [attr.role]="listing.prospectId ? 'link' : null" [attr.tabindex]="listing.prospectId ? 0 : null"
                 (click)="openProperty(listing)" (keydown.enter)="openProperty(listing)">
          <span class="match-label">{{ matchLabel(listing) }}</span>
          <h4>{{ listing.address || 'Address unavailable' }}</h4>
          <dl>
            <dt>Sold date</dt><dd>{{ listing.soldDate ? (listing.soldDate | date:'dd MMM yyyy') : '—' }}</dd>
            <dt>Price (AUD)</dt><dd class="listing-price">{{ listing.price != null ? (listing.price | currency:'AUD':'symbol-narrow':'1.0-2') : 'Price unavailable' }}</dd>
            <dt>Selling agency</dt><dd>{{ listing.sellCompany || '—' }}</dd>
          </dl>
        </article>
        </div>
      </section>
    </ng-container>
  </nb-card-body>
  <nb-card-footer *ngIf="agent && !loading && !error" class="detail-footer" [hidden]="!editing && !saveMessage">
    <div class="save-feedback" aria-live="polite">
      <span *ngIf="editing && (validationError || saveError)" role="alert">{{ validationError || saveError }}</span>
      <span *ngIf="!editing && saveMessage" role="status">{{ saveMessage }}</span>
    </div>
    <div *ngIf="editing" class="footer-actions">
      <button nbButton size="small" type="button" (click)="cancelEdit()" [disabled]="saving">Cancel</button>
      <button nbButton size="small" status="primary" type="submit" form="agent-profile-form" [disabled]="saving">
        {{ saving ? 'Saving…' : 'Save' }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
